import { useEffect, useRef } from 'react'
import { selectShouldDisplayMapTools } from '../../../store/ui/ui.selectors'
import { isGE } from '../../Device'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import { ScaleControl as MapLibreScaleControl } from 'maplibre-gl'
import './Scale.less'
import { useCallbackWithMapContext } from '../MapContext'

const Scale = () => {
  const scaleRef = useRef()

  const addControl = useCallbackWithMapContext(map => {
    if (scaleRef.current) return

    scaleRef.current = new MapLibreScaleControl({
      maxWidth: 120,
      unit: 'metric'
    })
    const position = isGE() ? 'bottom-right' : 'bottom-left'
    map.addControl(scaleRef.current, position)
  })

  const removeControl = useCallbackWithMapContext(map => {
    try {
      if (scaleRef.current) map.removeControl(scaleRef.current)
    } catch (e) {}
    scaleRef.current = undefined
  })

  useEffect(() => {
    addControl()
    return () => {
      if (scaleRef.current) removeControl()
    }
  }, [addControl, removeControl])

  return null
}

export default withEverySelectorTruthy(selectShouldDisplayMapTools)(Scale)
